import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import CoverageOptionEmployerOther from './CoverageOptionEmployerOther';

const mapStateToProps = ({User, Noyo}) => {
    return {
        currentUser: User.currentUser,
        carriers: Noyo.carriers
    }
};

const mapDispatchToProps = {};

const ConnectedCoverageOptionEmployerContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
        forwardRef: true,
    },
)(CoverageOptionEmployerOther);

export default forwardRef((props, ref) => {
    return <ConnectedCoverageOptionEmployerContainer {...props} ref={ref} />
})